import React from 'react';
import styles from './FileList.module.scss';
import FileComponent from '../FileComponent/FileComponent';

const FileList = ({ files, removeFile, onChangePreview }) => {
  const handleOpenPreview = (index) => {
    onChangePreview({ visible: true, value: index });
  };

  return (
    <div className={styles.root}>
      {files?.map((file, index) => (
        <FileComponent
          key={index}
          index={index}
          file={file}
          removeFile={removeFile}
          handleOpenPreview={handleOpenPreview}
          files={files}
          onChangePreview={onChangePreview}
        />
      ))}
    </div>
  );
};

export default FileList;
